import { ModalTypes, ModalDefaults, ActionConfigs, Sizes, Types, FieldTypes, Align, Backdrop, ActionSizes, Validators, Colors } from '../../Constants.js';

export function _initDatepickerFields(modal) {
    const { $body } = modal.elements;
    const $ = window.jQuery;
    const fields = modal._getAllFields().filter(field => field.type === FieldTypes.DATEPICKER);

    if (!fields.length || !$body) return;

    if (!window.GenericDatepickerBuilder || !$) {
        console.warn('[GenericModal] GenericDatepickerBuilder is not available. Datepicker fields will render as text inputs.');
        return;
    }

    fields.forEach(field => {
        const $input = $body.find('#' + field.id);
        if (!$input.length) return;

        const existing = $input.data('generic-datepicker');
        if (existing && typeof existing.destroy === 'function') existing.destroy();

        const builder = window.GenericDatepickerBuilder.create($input[0]);
        modal._applyDatepickerFieldConfig(builder, field, $input);

        const picker = builder.build();
        $input.data('generic-datepicker', picker);
        modal.datepickerInstances.push(picker);
    });
}

export function _applyDatepickerFieldConfig(modal, builder, field, $input) {
    const apply = (config = {}) => {
        if (!config || typeof config !== 'object') return;

        if (config.value !== undefined) builder.withValue(config.value);
        if (config.min !== undefined) builder.withMinDate(config.min);
        if (config.minDate !== undefined) builder.withMinDate(config.minDate);
        if (config.max !== undefined) builder.withMaxDate(config.max);
        if (config.maxDate !== undefined) builder.withMaxDate(config.maxDate);
        if (config.locale) builder.withLocale(config.locale);
        if (config.theme) builder.withTheme(config.theme);
        if (config.dateOnly) builder.withDateOnly();
        if (config.timeOnly) builder.withTimeOnly();
        if (config.timeToggle !== undefined) builder.withTimeToggle(config.timeToggle);
        if (config.compactTime !== undefined) builder.withCompactTime(config.compactTime);

        [
            ['year', 'withYear'], ['month', 'withMonth'], ['date', 'withDate'],
            ['hours', 'withHours'], ['minutes', 'withMinutes'], ['seconds', 'withSeconds'],
            ['yearValue', 'withYearValue'], ['monthValue', 'withMonthValue'], ['dateValue', 'withDateValue'],
            ['hoursValue', 'withHoursValue'], ['minutesValue', 'withMinutesValue'], ['secondsValue', 'withSecondsValue'],
            ['dateFilter', 'withDateFilter'], ['monthFilter', 'withMonthFilter'], ['yearFilter', 'withYearFilter'],
            ['hourFilter', 'withHourFilter'], ['minuteFilter', 'withMinuteFilter'], ['secondFilter', 'withSecondFilter'],
            ['onSelect', 'onSelect'], ['onOpen', 'onOpen'], ['onClose', 'onClose'], ['onChange', 'onChange']
        ].forEach(([key, method]) => {
            if (config[key] !== undefined && typeof builder[method] === 'function') {
                builder[method](config[key]);
            }
        });
    };

    apply(field);
    apply(field.datepickerOptions);
    apply(field.datePickerOptions);

    const datepickerConfig = field.datepicker || field.datePicker || field.configureDatepicker;
    if (typeof datepickerConfig === 'function') {
        datepickerConfig(builder, field);
    } else {
        apply(datepickerConfig);
    }

    const originalOnChange = builder._config && builder._config.onChange;
    builder.onChange((date, picker) => {
        if (typeof originalOnChange === 'function') originalOnChange(date, picker);
        $input.trigger('change');
    });
}

export function _destroyDatepickerFields(modal) {
    modal.datepickerInstances.forEach(instance => {
        if (instance && typeof instance.destroy === 'function') instance.destroy();
    });
    modal.datepickerInstances = [];
}

